function CategoryB() {
    return (
        <div>
            CategoryB
        </div>
    );
}

export default CategoryB;